/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Actions from '../../../actions/Setting';
import Template from '../../../components/Template/AfterLoginTemplate';
import * as RT from '../../../constants/Routing';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      load_end: false,
      setting: this.props.Setting.currentSetting,
      categories: [],
      currentCategory: ''
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  componentWillMount = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getSetting(enterpriseId, token, this.currentUser.email);
  };

  componentWillReceiveProps = props => {
    if (this.props.Setting.currentSettingLoaded) {
      console.log('TCL: this.props.Setting', this.props.Setting);

      this.setState({
        load_end: true,
        setting: props.Setting.currentSetting,
        categories: props.Setting.categories
      });
      console.log(
        'TCL: this.state.setting.enterpriseCategory',
        this.state.setting.enterpriseCategory
      );
      this._getCategoryName(this.state.setting.enterpriseCategory);
    }
  };

  _getCategoryName = key => {
    if (!this.state.categories.length || this.state.categories.length === 0) return;
    console.log('TCL: Component -> this.state.categories', this.state.categories);

    const categoryObj = this.state.categories.find(cat => cat.value === key);
    if (categoryObj !== undefined && categoryObj.value.length !== 0) {
      this.setState({ currentCategory: categoryObj.value });
    }
  };

  _renderPreviewImage = () => {
    const hasImage = this.state.image !== '';
    return (
      <div className="col-12 image-wrap mt-3 p-2">
        <div
          // eslint-disable-next-line react/no-string-refs
          ref="image"
          className={
            hasImage ? 'img-fluid task-preview-image' : 'img-fluid task-preview-image hidden'
          }
          style={{
            backgroundImage: `url(${this.state.setting.enterprisePhotoId})`
          }}
        />
        <span className={hasImage ? 'hidden' : ''}>
          ここに画像が表示されます。
          <br />
          （画像は縦横比 3:4 に切り取られます。）
        </span>
      </div>
    );
  };

  _editSetting = e => {
    e.preventDefault();
    const { history } = this.props;
    const { setting, categories } = this.state;
    const childProps = {
      setting,
      categories
    };
    history.push(RT.SETTING_EDIT_PATH, childProps);
  };

  _signOut = e => {
    e.preventDefault();
    localStorage.removeItem('current_user');
    this.props.history.push(RT.SIGN_IN_PATH);
  };

  render = () => {
    return (
      <Template>
        <div className="">
          <h2>設定</h2>
          <h3>事業者情報</h3>
          <div className="row">
            <div className="form-group position-relative col-3">
              <label htmlFor="category">事業者カテゴリー</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="category"
                placeholder="未入力"
                value={this.state.currentCategory}
              />
            </div>
            <div className="form-group position-relative col-7">
              <label htmlFor="name">事業者名</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="name"
                placeholder="未入力"
                value={this.state.setting.enterpriseName}
              />
            </div>
            <div className="form-group position-relative col-3">
              <label htmlFor="postcode">郵便番号</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="postcode"
                placeholder="未入力"
                value={this.state.setting.postalCode}
              />
            </div>
            <div className="form-group position-relative col-7">
              <label htmlFor="address">住所</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="address"
                placeholder="未入力"
                value={
                  this.state.setting.prefecture +
                  this.state.setting.municipality +
                  this.state.setting.street
                }
              />
            </div>
            <div className="form-group position-relative col-3">
              <label htmlFor="email">メールアドレス</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="email"
                placeholder="未入力"
                value={this.state.setting.email}
              />
            </div>
            <div className="form-group position-relative col-4">
              <label htmlFor="phone">電話番号</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="phone"
                placeholder="未入力"
                value={this.state.setting.phone}
              />
            </div>

            {/*<div className="form-group position-relative col-3">*/}
            {/*  <label htmlFor="phone">手数料率</label>*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    readOnly*/}
            {/*    className="form-control"*/}
            {/*    id="feeRate"*/}
            {/*    placeholder="未入力"*/}
            {/*    value={this.state.setting.feeRate}*/}
            {/*  />*/}
            {/*</div>*/}

            <div className="form-group position-relative col-3">
              <label htmlFor="station">最寄駅</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="station"
                placeholder="未入力"
                value={this.state.setting.stationName}
              />
            </div>
            <div className="form-group position-relative col-4">
              <label htmlFor="access">アクセス</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="access"
                placeholder="未入力"
                value={this.state.setting.way}
              />
            </div>
            <div className="form-group position-relative col-3">
              <label htmlFor="worktime">稼働時間</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="worktime"
                placeholder="未入力"
                value={this.state.setting.workTime}
              />
            </div>
            <div className="form-group position-relative col-3">
              <label htmlFor="picTitle">代表者役職</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="picTitle"
                placeholder="未入力"
                value={this.state.setting.picTitle}
              />
            </div>
            <div className="form-group position-relative col-4">
              <label htmlFor="picName">代表者氏名</label>
              <input
                type="text"
                readOnly
                className="form-control"
                id="picName"
                placeholder="未入力"
                value={this.state.setting.picName}
              />
            </div>
            <div className="form-group position-relative col-10">
              <label htmlFor="img">アイキャッチ画像</label>
              {this._renderPreviewImage()}
            </div>
            <div className="form-group position-relative col-10">
              <label htmlFor="description">施設の紹介文</label>
              <input
                type="text"
                readOnly
                className="form-control"
                placeholder="未入力"
                value={this.state.setting.description}
              />
            </div>
            <div className="form-group position-relative col-7">
              <button type="button" className="btn btn-success" onClick={this._editSetting}>
                編集する
              </button>
            </div>
          </div>
          <br />
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
